import { tabsterAttributeName } from "../utilities";

/**
 * Minimum properties associated with the tabster attribute property.
 */
export type StateWithTabsterAttributes = {
  root: {
    [K in typeof tabsterAttributeName]?: string;
  };
};

/**
 * Process the `state` as a mutable draft state and set the tabster attribute property
 * according to `tabsterAttributes`.
 */
export function useTabsterAttributes<T extends StateWithTabsterAttributes>(
  state: T,
  tabsterAttributes?: string
) {
  if (tabsterAttributes) {
    state.root[tabsterAttributeName] = tabsterAttributes;
  }
}
